import { useEffect, useState } from "react";
import axios from "axios";
import { useEffectAsync } from "@alphascriptsolutions/client-core";
import { apiBase, authHeaders } from "@/utils/apiClient";
import { logger } from "@/helpers/tslog";

export function useSlideJobPreview(jobId: string, isComplete: boolean): string | null {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffectAsync(async () => {
    if (!isComplete || previewUrl || !apiBase() || !jobId) return;
    try {
      const { data } = await axios.get<ArrayBuffer>(`${apiBase()}/slide-generation/download`, {
        params: { jobId, type: "image", slideNumber: 1, chartNumber: 1 },
        headers: await authHeaders(),
        responseType: "arraybuffer",
        withCredentials: true,
      });
      const blob = new Blob([data], { type: "image/png" });
      setPreviewUrl(URL.createObjectURL(blob));
    } catch (error) {
      logger.warn("[useSlideJobPreview] Failed to load preview image", error);
    }
  }, [isComplete, jobId, previewUrl]);

  useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  return previewUrl;
}
